import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=e0f3d86c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=e0f3d86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f3d86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0f3d86c')) {
      api.createRecord('e0f3d86c', component.options)
    } else {
      api.reload('e0f3d86c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=e0f3d86c&scoped=true&", function () {
      api.rerender('e0f3d86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n1n1Tw2dFAm3/JS/comp/DocBox.vue"
export default component.exports